import axios from 'axios';

export const contactRequestService = async ({ firstName, lastName, email, phoneNumber, message }) => {
    try {
        const response = await axios.post('/api/contact-requests', {
            first_name: firstName,
            last_name: lastName,
            email,
            phone_number: phoneNumber,
            message,
        });
        return response.data;
    } catch (error) {
        console.error('Error submitting contact request:', error);
        throw error;
    }
};
